import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/pvsa/form-data"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const formDataApi = createApi({
    reducerPath: "formDataApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: ['FormDataVariables', 'FormMultiData', 'FormSingleData'],
    endpoints: (builder) => ({
        getSingleFormData: builder.query({
            query: ({ sectionId, movementId }) => `?section-id=${sectionId}&movement-id=${movementId}&type=single`,
            transformResponse: (response) => response.data,
            providesTags: ['FormSingleData']
        }),
        createOrUpdateSingleFormData: builder.mutation({
            query: (obj) => ({
                url: `/?type=single`,
                method: "POST",
                body: obj,
            }),
            invalidatesTags: ['FormDataVariables', 'FormSingleData']
        }),
        getMultiFormData: builder.query({
            query: ({ sectionId, movementId, elementId }) =>
                `?section-id=${sectionId}&movement-id=${movementId}&element-id=${elementId}&type=multi`,
            transformResponse: (response) => response.data,
            providesTags: ["FormMultiData"],
        }),
        createMultiFormData: builder.mutation({
            query: (obj) => ({
                url: `/?type=multi`,
                method: "POST",
                body: obj,
            }),
            invalidatesTags: ["FormMultiData"],
        }),
        getOneMultiFormData: builder.query({
            query: (row_ref) => `/${row_ref}`,
            transformResponse: (response) => response.data,
        }),
        updateMultiFormData: builder.mutation({
            query: ({ rowRef, entries }) => ({
                url: `/${rowRef}`,
                method: "PUT",
                body: {entries},
            }),
            invalidatesTags: ["FormMultiData"],
        }),
        deleteMultiFormData: builder.mutation({
            query: (rowRef) => ({
                url: `/${rowRef}`,
                method: "DELETE",
            }),
            invalidatesTags: ["FormMultiData"],
        }),
        getFormDataVariables: builder.query({
            query: (movementId) => `/variables?mission-id=${movementId}`,
            transformResponse: (response) => response.data,
            providesTags: ["FormDataVariables"],
        }),
    }),
});

export const {
    useGetSingleFormDataQuery,
    useCreateOrUpdateSingleFormDataMutation,
    useGetMultiFormDataQuery,
    useCreateMultiFormDataMutation,
    useLazyGetOneMultiFormDataQuery,
    useUpdateMultiFormDataMutation,
    useDeleteMultiFormDataMutation,
    useGetFormDataVariablesQuery,
    useLazyGetFormDataVariablesQuery
} = formDataApi;
